/**
 * Fetch wrapper that attaches the JWT from magic-link exchange to requests.
 * Use for all calls to protected backend APIs (e.g. POST /consult-scheduling/schedule).
 *
 * @param jwt - Bearer token from POST /link/exchange response.
 * @param url - Request URL (relative to origin or absolute).
 * @param init - Optional fetch init; headers are merged with Authorization.
 * @returns Promise from fetch.
 *
 * @example
 * const res = await authFetch(jwt, '/v1/consult-scheduling/schedule', {
 *   method: 'POST',
 *   headers: { 'Content-Type': 'application/json' },
 *   body: JSON.stringify({ scheduledStart, scheduledEnd, timeZone, channel }),
 * });
 */
export function authFetch(jwt: string, url: string, init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers);
  headers.set('Authorization', `Bearer ${jwt}`);
  return fetch(url, { ...init, headers });
}
